import Model from '../Model'

export default class Country extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/dictionary/countries'
    }
}
